<!-- Select Project -->
<label>{{'widgets.project.projectName' | translate}}</label>
<div class="dropdown">
  <select class="dropdown__select" [(ngModel)]="selectedProjectKey" (change)="onSelectedProjectChanged()">
    <option class="dropdown__item" *ngFor="let projectKey of availableProjectKeys" [value]="projectKey">
      {{projectKey}}
    </option>
  </select>
  <div class="dropdown__icon">
    <i class="material-icons">keyboard_arrow_down</i>
  </div>
</div>

<!-- Select Sprint -->
<label>{{'widgets.project.sprintName' | translate}}</label>
<div class="dropdown">
  <select class="dropdown__select" [(ngModel)]="selectedSprintId" (change)="onSelectedSprintChanged()">
    <option class="dropdown__item" *ngFor="let sprint of sprints" [value]="sprint.id"
      [ngClass]="{'active' : (sprint.state == 'active')}">{{sprint.name}}
    </option>
  </select>
  <div class="dropdown__icon">
    <i class="material-icons">keyboard_arrow_down</i>
  </div>
</div>

<!-- This button allows to reload data for an already selected sprint -->
<div id="reload-button">
  <button mat-mini-fab color="accent" (click)="forceUpdate()" title="Reload">
    <mat-icon>refresh</mat-icon>
  </button>
</div>

<!-- Project Vision -->
<label>{{'widgets.project.vision' | translate}}</label>
<div id='projectvision' *ngIf="this.project">
  <div *ngIf="!editModeProjectVision">
    <mat-form-field>
      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" readonly
        [(ngModel)]="project.vision"></textarea>
    </mat-form-field>
    <mat-icon (click)="toggleProjectVisionEdit($event)">edit</mat-icon>
  </div>
  <div *ngIf="editModeProjectVision">
    <mat-form-field>
      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
        [(ngModel)]="project.vision" (keyup.enter)="toggleProjectVisionEdit($event)"></textarea>
    </mat-form-field>
    <mat-icon (click)="changeProjectVision($event)">check_circle</mat-icon>
  </div>
</div>
